import { render, staticRenderFns } from "./MobilePreventionHealthRequest.vue?vue&type=template&id=2df9aeec&scoped=true&"
import script from "./MobilePreventionHealthRequest.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionHealthRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df9aeec",
  null
  
)

export default component.exports